import script from "./ServiceCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCenter.vue?vue&type=style&index=0&id=a1ee64f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1ee64f0"]])

export default __exports__